import { render } from "./AppListItemGroup.vue?vue&type=template&id=40fa1cb6"
import script from "./AppListItemGroup.vue?vue&type=script&lang=js"
export * from "./AppListItemGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__